var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: {
        column: "",
        role: "region",
        "aria-label": "Disenchantment Guide Page",
      },
    },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/disenchanting-cover.png",
          height: "400",
          "aria-label": "Background artwork for the Disenchantment guide",
          role: "img",
        },
      }),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-card",
            {
              attrs: {
                role: "region",
                "aria-label": "Introduction to Disenchantment",
              },
            },
            [
              _c(
                "v-app-bar",
                {
                  staticClass: "font-weight-thin text-uppercase",
                  attrs: {
                    flat: "",
                    color: "primary",
                    role: "heading",
                    "aria-level": "1",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("components.guides.pages.disenchantment.title")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "components.guides.pages.disenchantment.description"
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.filteredErrors,
                function (errorsGroup, errorsGroupIndex) {
                  return _c(
                    "div",
                    {
                      key: errorsGroupIndex,
                      attrs: { "aria-live": "polite", role: "alert" },
                    },
                    _vm._l(errorsGroup, function (error) {
                      return _c(
                        "v-alert",
                        {
                          key: error.id,
                          attrs: {
                            type: error.type,
                            icon: error.icon,
                            role: "alert",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(error.msg) + "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card",
            {
              attrs: {
                flat: "",
                role: "search",
                "aria-label": "Search Disenchantable Items",
              },
            },
            [
              _c(
                "v-layout",
                {
                  class: { column: _vm.$vuetify.breakpoint.mdAndDown },
                  attrs: { "py-8": "", "px-8": "", "pt-4": "", "my-7": "" },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t(
                        "components.guides.pages.disenchantment.searchLabel"
                      ),
                      "aria-describedby": "search-desc",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "sr-only", attrs: { id: "search-desc" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.guides.pages.disenchantment.searchDescription"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mt-1 ml-2",
                      attrs: {
                        "aria-label": "Search disenchantable items",
                        color: "accent",
                        type: "button",
                        large: "",
                      },
                      on: { click: _vm.startSearching },
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { small: "", "aria-hidden": "true" } },
                        [_vm._v("\n            fad fa-search\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              attrs: {
                "my-2": "",
                "mx-2": "",
                column: "",
                role: "region",
                "aria-label": "Disenchantable Items List",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { attrs: { role: "heading", "aria-level": "2" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.guides.pages.disenchantment.disenchantableItems.title"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.disenchantableItemsData.headers,
                      items: _vm.disenchantableItemsData.items,
                      search: _vm.tableSearch,
                      loading: _vm.isLoading,
                      "loading-text": "Loading... Please wait",
                      "no-results-text": "Nothing was found",
                      "no-data-text": "Nothing was found",
                      "items-per-page": 10,
                      "sort-by": "item_name",
                      "group-desc": "",
                      color: "secondary",
                      "footer-props": {
                        showFirstLastPage: true,
                        firstIcon: "fad fa-chevron-double-left",
                        lastIcon: "fad fa-chevron-double-right",
                        prevIcon: "fad fa-chevron-left",
                        nextIcon: "fad fa-chevron-right",
                      },
                      "aria-label": _vm.$t(
                        "components.guides.pages.disenchantment.disenchantableItems.title"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("v-progress-linear", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isLoading,
                                  expression: "isLoading",
                                },
                              ],
                              attrs: {
                                color: "accent",
                                indeterminate: "",
                                "aria-label": "Loading disenchantable items",
                                role: "status",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              attrs: {
                "my-2": "",
                "mx-2": "",
                column: "",
                role: "region",
                "aria-label": "Obtainable Materials List",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { attrs: { role: "heading", "aria-level": "2" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "components.guides.pages.disenchantment.obtainableMaterials.title"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.obtainableMaterialsData.headers,
                      items: _vm.obtainableMaterialsData.items,
                      search: _vm.search,
                      loading: _vm.isLoading,
                      "loading-text": "Loading... Please wait",
                      "no-results-text": "Nothing was found",
                      "no-data-text": "Nothing was found",
                      "items-per-page": 10,
                      "sort-by": "item_name",
                      "group-desc": "",
                      color: "secondary",
                      "footer-props": {
                        showFirstLastPage: true,
                        firstIcon: "fad fa-chevron-double-left",
                        lastIcon: "fad fa-chevron-double-right",
                        prevIcon: "fad fa-chevron-left",
                        nextIcon: "fad fa-chevron-right",
                      },
                      "aria-label": _vm.$t(
                        "components.guides.pages.disenchantment.obtainableMaterials.title"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "progress",
                        fn: function () {
                          return [
                            _c("v-progress-linear", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isLoading,
                                  expression: "isLoading",
                                },
                              ],
                              attrs: {
                                color: "accent",
                                indeterminate: "",
                                "aria-label": "Loading obtainable materials",
                                role: "status",
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }